<template>
  <div class="comments">
    <div class="comment_con">
      <h1 class="header">Select or write a new comment to post</h1>
      <div v-if="!isDatapresent" class="loader">
        <v-progress-circular
          :width="6"
          :size="80"
          color="green"
          indeterminate
        ></v-progress-circular>
      </div>
      <div v-else>
        <div class="emptycomment" v-if="comments.length === 0">
          <p>You can add your default answers here .</p>
        </div>
        <div
          v-for="comment in comments"
          :key="comment.id"
          class="flex comment-con"
        >
          <div @click="handleSeletedComment(comment.text)" class="comment">
            <p>{{ comment.text }}</p>
            <hr />
          </div>
          <div @click="removeComment(comment.id)" class="cross-icon">
            <p>X</p>
          </div>
        </div>
      </div>
    </div>

    <v-text-field
      filled
      light
      outlined
      placeholder="Add a new comment.."
      append-icon="mdi-send"
      background-color="#F6F9F6"
      class="mt-5 input_field"
      @keyup.enter="addcomments()"
      @click:append="addcomments()"
      value="null"
      v-model="clipedQueryinput"
    ></v-text-field>

    <v-overlay v-if="showconfirmmsg" opacity="0.8">
      <div class="confirm-msg">
        <h5>
          Are you sure you want to send this message to the selected
          {{ myState.length }} farmers?
        </h5>
        <p>{{ selectedcomment }}</p>
        <div class="flex filter-buttons">
          <button class="clear" @click="showconfirmmsg = false">Cancel</button>
          <button class="done" @click="sendbulkmsg">Confirm</button>
        </div>
      </div>
    </v-overlay>

    <v-overlay v-if="donebtnclicked" opacity="0.8">
      <div class="confirm-msg">
        <v-progress-circular
          :width="6"
          :size="80"
          color="green"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-overlay>

    <v-overlay v-if="sucess" opacity="0.8">
      <div class="sucess-msg">
        <v-icon class="icon" color="#419045">mdi-check-circle</v-icon>
        <h3 class="secondary-font">Your message has been sent successfully.</h3>
        <button @click="sucess = false" class="closebtn bold --green">
          Close
        </button>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import API_URL from "../../../../helpers/apiUrls";
import accessToken from "../../../../helpers/accessToken";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

export default {
  ...mapActions(["GET_SELECTED_QUERY"]),
  name: "addComment",

  data() {
    return {
      comments: [],
      clipedQueryinput: "",
      isDatapresent: false,
      business_id: "",
      selectedcomment: "",
      showconfirmmsg: false,
      selectedQuery: [],
      selectedQueryNo: 0,
      donebtnclicked: false,
      sucess: false,
    };
  },

  methods: {
    getSelectedQuery() {
      this.selectedQuery = this.$store.getters["queryStore/GET_SELECTED_QUERY"];
      this.selectedQueryNo = this.selectedQuery.length;
    },
    handleSeletedComment(text) {
      this.showconfirmmsg = true;
      this.selectedcomment = text;
    },
    removeComment(id) {
      const successHandler = (response) => {
        this.toggleLoader(false);
        if (response.status === 200) {
          this.getComments();
        }
      };

      const errorHandler = (error) => {
        this.showToast("Something went wrong internally!", "error", 10000);
        console.log(error);
      };
      this.business_id = accessToken.getCredentials().brandID;

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
        "BRAND-ID": this.business_id,
      };

      this.requestDELETE(
        `${API_URL.deleteClipedQuery}?business_id=${this.business_id}&id=${id}`,
        {},
        headers,
        successHandler,
        errorHandler
      );
    },
    addcomments() {
      const successHandler = (response) => {
        if (response.status === 200) {
          console.log("ADD COMMENT RES ", response.data);
          this.getComments();
        }
      };

      const errorHandler = (error) => {
        this.showToast("Something went wrong internally!", "error", 10000);
        console.log(error);
      };
      this.business_id = accessToken.getCredentials().brandID;

      const data = {
        text: this.clipedQueryinput,
        business_id: this.business_id,
      };

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
        "BRAND-ID": this.business_id,
      };
      this.clipedQueryinput = "";

      this.requestPOST(
        `${API_URL.addClipedQuery}?business_id=${this.business_id}`,
        data,
        headers,
        successHandler,
        errorHandler
      );
    },

    // post bulk comment
    sendbulkmsg() {
      // console.log(this.clipedQueryinput);
      if (this.myState.length === 0) {
        this.showToast(
          "Please select atleast 1 query to respond.",
          "success",
          10000
        );
      } else {
        this.donebtnclicked = true;
        this.showconfirmmsg = false;
        const successHandler = (response) => {
          if (response.status === 200) {
            console.log("ADD COMMENT RES ", response.data);
            this.$store.dispatch("queryStore/removeSelectedQuery");
            this.donebtnclicked = false;
            this.sucess = true;
            this.$emit("sendbulkmsgclicked");
          }
        };

        const errorHandler = (error) => {
          this.showToast("Something went wrong internally!", "error", 10000);
          console.log(error);
          this.donebtnclicked = false;
        };
        this.business_id = accessToken.getCredentials().brandID;

        const data = {
          feed_type: "post_feed",
          comment: this.selectedcomment,
          post_id: this.myState,
          comment_author_type: "business",
          business_id: this.business_id,
        };

        const headers = {
          Authorization: `Bearer ${accessToken.getAccessToken()}`,
        };

        this.requestPOST(
          `${API_URL.postbulkComment}`,
          data,
          headers,
          successHandler,
          errorHandler
        );
      }
    },

    // get all comments
    getComments() {
      this.isDatapresent = false;
      const successHandler = (response) => {
        this.toggleLoader(false);
        if (response.status === 200) {
          this.isDatapresent = true;
          console.log("res ", response);
          this.comments = response.data.results;
        }
      };

      const errorHandler = (error) => {
        this.showToast("Something went wrong internally!", "error", 10000);
        this.isDatapresent = true;
        console.log(error);
        this.toggleLoader(false);
      };
      this.business_id = accessToken.getCredentials().brandID;
      console.log("this.business_id", this.business_id);

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
        "BRAND-ID": this.business_id,
      };

      this.requestGET(
        `${API_URL.getClipedQuerylist}?business_id=${this.business_id}`,
        {},
        headers,
        successHandler,
        errorHandler
      );
    },
  },
  computed: {
    ...mapGetters("queryStore", {
      myState: "getSelectedQueries",
    }),
  },
  mounted() {
    this.getComments();
    this.getSelectedQuery();
  },
};
</script>

<style lang="scss" scoped>
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;
}
.comments {
  padding: 40px 40px 0px 40px;
}
.comment_con {
  max-height: 500px;
  overflow-y: auto;
  scroll-margin: 100px;
}
.header {
  font-size: 1.5rem;
  color: #1d8d56;
  margin-bottom: 24px;
  font-weight: 500;
}
.comment-con {
  column-gap: 30px;
  cursor: pointer;
  justify-content: space-between;
  margin-right: 10px;

  p {
    color: #5b5b5b;
    font-weight: 500;
    font-size: 0.9rem;
    width: 100%;
  }
}
.comment {
  width: 100%;

  hr {
    border: 1px solid #e0e0e0;
    margin-bottom: 15px;
  }
}

.cross-icon {
  background: rgba(49, 138, 54, 0.05);
  border-radius: 5px;
  padding: 1px 10px;

  p {
    font-weight: 600;
    color: #2baa6c;
    font-size: 1.2em;
    margin-bottom: 0px;
  }

  cursor: pointer;
}
.input_field {
  position: relative;
  bottom: 10px;
  padding: 10px 0px;
}
.search-con {
  background: #f6f9f6;
  border-radius: 3px;
  width: 100%;
  padding: 15px 25px;
  margin-top: 20px;
}
::placeholder {
  color: #a5afa9;
  font-weight: 500;
}
.emptycomment {
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.confirm-msg {
  width: 644px;
  min-height: 230px;
  background-color: #ffffff;
  border-radius: 3px;
  padding: 30px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  h5 {
    color: #445149;
    font-weight: 500;
    font-size: 18px;
  }
  p {
    color: #349039;
    font-weight: 400;
    font-size: 16px;
    margin-top: 20px;
  }
}
.sucess-msg {
  width: 644px;
  min-height: 230px;
  background-color: #ffffff;
  border-radius: 3px;
  padding: 30px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  h3 {
    font-size: 1.2rem;
  }
}
.closebtn {
  width: 100%;
  background: rgba(49, 138, 54, 0.05);
  color: #1d8d56;
  padding: 14px;
  font-weight: 500;
  align-self: flex-end;
  margin-top: 30px;
}
.icon {
  font-size: 4rem;
  margin: 20px auto;
}
.filter-buttons {
  width: 100%;
  column-gap: 20px;
  margin-top: 10px;

  button {
    padding: 15px 20px;
    border-radius: 5px;
    font-size: 1rem;
    font-weight: 500;
  }
}
.clear {
  background-color: rgba(57, 186, 123, 0.11);
  width: 50%;
  color: #328736;
}
.done {
  background-color: #36983b;
  width: 50%;
  color: #fff;
}

//scrollbar
::-webkit-scrollbar {
  width: 8px;
  margin: 3px;
  border-left: 1px solid rgba(50, 52, 65, 0.1);
  border-right: 1px solid rgba(50, 52, 65, 0.1);
  margin-left: 100px;
}

::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: rgba(50, 52, 65, 0.15);
  //   border: 4px solid transparent;
  background-clip: content-box;
}
::-webkit-scrollbar-track {
  width: 8px;
}
::-webkit-scrollbar-corner {
  //   display: none;
  height: 0px;
  width: 0px;
}
</style>
